import Vue from "vue";
import Component from "vue-class-component";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import { Prop } from "vue-property-decorator";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "ShippingAddressEdit" })
export default class ShippingAddressEdit extends Vue {
    public localizer: any = Localizer;
    public formHelper: any = FormHelper;
    public validationErrors: any[] = [];
    public isLoading: boolean = false;
    public isSuccess: boolean = false;
    public isCompany: boolean = false;
    public formData: any = { country: "IT", zone: null };

    get routes() {
        return (<any>window).App.routes;
    }

    @Prop() readonly countries: any;
    @Prop() readonly provinces: any;
    @Prop() readonly shippingAddress: any;

    public async created() {
        await this.getData();
    }

    public async getData() {
        let data = (await Axios.post(this.routes.MyBeghelliShippingAddress_GetShippingAddress, { idMaster: this.shippingAddress?.idMaster })).data;
        
        if (this.shippingAddress?.idMaster) {
            this.formData = data.address;
        }
        this.isCompany = data.isCompany;
    }

    public setCountryType() {
        this.formData.zone = null;
    }

    public cancelEdit() {
        this.$emit("isEditAddress", false);
    }

    public async submitForm() {
        FormHelper.removeFocus();
        this.validationErrors = [];
        this.isLoading = true;

        try {
            await Axios.post(this.routes.MyBeghelliShippingAddress_SaveShippingAddress, this.formData);

            this.isSuccess = true;
            this.$emit("isEditAddress", false);
        } catch (error) {
            if (error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        this.isLoading = false;
    }

    public isValidationError(controlName: string): boolean {
        return FormHelper.isControlValidationError(controlName, this.validationErrors);
    }
};